module.exports = __webpack_public_path__ + "img/favicon.e4fba312.ico";